import React, { useState } from "react";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import "./VehicleList.css";
import { VEHICLE_TYPE } from "../../../../../utils/constants";

const VehicleList = ({ items, isEditable, onDelete, isApproved }) => {
  const [openItemIndex, setOpenItemIndex] = useState(null);

  const toggleDetails = (index) => {
    setOpenItemIndex(openItemIndex === index ? null : index);
  };

  return (
    <div className="vehicle-list-card">
      <div className="vehicle-list">
        {items.map((item, index) => (
          <div key={index}>
            <div className="vehicle-item">
              <span className="vehicle-title">{`Vehicle ${index + 1}`}</span>
              <div className="item-actions-container">
                {!isApproved && isEditable ? (
                  <DeleteOutlined
                    className="item-action-delete"
                    onClick={() => onDelete(index)}
                  />
                ) : null}
                {openItemIndex === index ? (
                  <UpOutlined
                    className="item-action"
                    onClick={() => toggleDetails(index)}
                  />
                ) : (
                  <DownOutlined
                    className="item-action"
                    onClick={() => toggleDetails(index)}
                  />
                )}
              </div>
            </div>

            {openItemIndex === index && (
              <div className="vehicle-details">
                <p>
                  <span>Vehicle Make:</span> {item.vehicleName}
                </p>
                <p>
                  <span>Registration Number:</span> {item.licensePlateNumber}
                </p>
                <p>
                  <span>Driver Name:</span> {item.driverName}
                </p>
                <p>
                  <span>Vehicle Type:</span>{" "}
                  {
                    VEHICLE_TYPE.find(
                      (type) => type.value === item.escortVehicleType
                    )?.name
                  }
                </p>
              </div>
            )}
            <div className="divider"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VehicleList;
